var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneplus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_56628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0009 1.5C12.0009 1.36739 12.0536 1.24021 12.1474 1.14645C12.2411 1.05268 12.3683 1 12.5009 1C12.6335 1 12.7607 1.05268 12.8545 1.14645C12.9483 1.24021 13.0009 1.36739 13.0009 1.5V4H15.5009C15.6335 4 15.7607 4.05268 15.8545 4.14645C15.9483 4.24021 16.0009 4.36739 16.0009 4.5C16.0009 4.63261 15.9483 4.75979 15.8545 4.85355C15.7607 4.94732 15.6335 5 15.5009 5H13.0009V7.5C13.0009 7.63261 12.9483 7.75979 12.8545 7.85355C12.7607 7.94732 12.6335 8 12.5009 8C12.3683 8 12.2411 7.94732 12.1474 7.85355C12.0536 7.75979 12.0009 7.63261 12.0009 7.5V5H9.50093C9.36832 5 9.24115 4.94732 9.14738 4.85355C9.05361 4.75979 9.00093 4.63261 9.00093 4.5C9.00093 4.36739 9.05361 4.24021 9.14738 4.14645C9.24115 4.05268 9.36832 4 9.50093 4H12.0009V1.5ZM5.75693 7.023L6.82993 6.039C7.1236 5.76942 7.33 5.41823 7.42266 5.03051C7.51531 4.64279 7.48998 4.23623 7.34993 3.863L6.89293 2.64C6.72182 2.18342 6.38307 1.80925 5.9457 1.59372C5.50833 1.3782 5.00524 1.33753 4.53893 1.48C2.82293 2.005 1.50393 3.6 1.90993 5.494C2.25268 7.06829 2.84194 8.57857 3.65593 9.969C4.62593 11.636 5.73393 12.869 6.68393 13.734C8.11793 15.04 10.1679 14.713 11.4869 13.484C11.8408 13.1543 12.0555 12.702 12.0873 12.2194C12.1191 11.7368 11.9655 11.2603 11.6579 10.887L10.8179 9.867C10.5645 9.55873 10.2246 9.33333 9.84195 9.21981C9.45934 9.1063 9.05151 9.10984 8.67093 9.23L7.28293 9.667C6.92446 9.29746 6.61034 8.88735 6.34693 8.445C6.09258 7.99705 5.89442 7.51944 5.75693 7.023Z",
    fill: "#002A24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_56628"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneplus);
export default __webpack_public_path__ + "static/media/phoneplus.eadf8643875fa97e8d1624bf0684d5ae.svg";
export { ForwardRef as ReactComponent };